import { Field } from 'formik';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DateTime as DT } from 'luxon';
import type { ServiceEditType } from '../../types';

interface ServiceFormAdditionalProps {
    values: ServiceEditType;
}

const ServiceFormAdditional = ({ values }: ServiceFormAdditionalProps) => {
    const { t } = useTranslation(['Services']);
    const [src, setSrc] = useState(values?.userPicture || '/imgs/user.png');

    return (
        <div className="d-sm-flex">
            <div className="text-center pb-4 pe-4">
                <img
                    className="wid-60 shadow rounded cursor-pointer"
                    src={src}
                    alt=""
                    onError={() => {
                        setSrc('/imgs/user.png');
                    }}
                />
            </div>

            <div className="w-100">
                <Form.Group className="mb-3 w-100">
                    <label className="form-label text-muted">{t('fields.owner')}</label>
                    <Field disabled={true} name="userName" className="form-control" />
                </Form.Group>

                <Form.Group className="mb-3 w-100">
                    <label className="form-label text-muted">Email</label>
                    <Field disabled={true} name="userEmail" className="form-control" />
                </Form.Group>

                <Form.Group className="mb-3 w-100">
                    <label className="form-label text-muted">{t('fields.createdFull')}</label>
                    <Field
                        disabled={true}
                        value={DT.fromMillis(values?.servCreated || 0).toLocaleString(DT.DATETIME_MED)}
                        className="form-control"
                    />
                </Form.Group>

                <Form.Group className="mb-3 w-100">
                    <label className="form-label text-muted">{t('fields.updatedFull')}</label>
                    <Field
                        disabled={true}
                        value={DT.fromMillis(values?.servUpdated || 0).toLocaleString(DT.DATETIME_MED)}
                        className="form-control"
                    />
                </Form.Group>
            </div>
        </div>
    );
};

export default ServiceFormAdditional;
